import { useItems } from "@adamlip/okeoke.client"
import { ScrollShadow } from "@nextui-org/react"
import ContentBox from "components/ContentBox"
import CategoryItems from "./CategoryItems"
import { AppParamsContext } from "contexts/AppParamsContext"
import { useContext } from "react"

export default function ItemListByCategory({ readOnly }) {
  const { categoryTree, categories } = useItems()
  const { appParams } = useContext(AppParamsContext)
  const filterFunction = (category) => {
    return (
      categories[category.uuid]?.enabled &&
      (category.availability?.availableItems > 0 ||
        category.availability?.availableSubItems > 0) &&
      (category.availability?.visibleItems > 0 ||
        category.availability?.visibleSubItems > 0)
    )
  }

  return (
    <>
      <ScrollShadow id="orderItemList-byCategory" className="grow">
        <div
          id="orderItemList-byCategory"
          className="orderItemList-byCategory-root scroll-shadow"
        >
          {<ContentBox place="order_page" />}
          {categoryTree.filter(filterFunction).map((category, index) => (
            <div
              key={index}
              className={`orderItemList-byCategory-category-root ${appParams?.styles?.gaps?.categoryGap || "mb-4"
                }`}
            >
              {<ContentBox place="before_category_items" categoryUUID={category?.uuid} />}
              <CategoryItems
                selectedCategory={category?.uuid}
                className={"main-category"}
                readOnly={readOnly}
              />
              {category?.categories != null &&
                category.categories
                  .filter(filterFunction)
                  .map((subCategory) => (
                    <CategoryItems
                      key={subCategory.uuid}
                      selectedCategory={subCategory.uuid}
                      className={"sub-category"}
                      readOnly={readOnly}
                    />
                  ))}
            </div>
          ))}
        </div>
      </ScrollShadow>
    </>
  )
}
